import React from 'react';
import { Card, Row, Col, Space, Select, Typography } from 'antd';
import { GlobalOutlined } from '@ant-design/icons';
import { useSupportedLanguages } from '@/utils/languageConfig';

const { Text } = Typography;

export interface ContentLanguageSelectorProps {
	value: string;
	onChange: (value: string) => void;
	style?: React.CSSProperties;
	extra?: React.ReactNode;
}

const ContentLanguageSelector: React.FC<ContentLanguageSelectorProps> = ({
	value,
	onChange,
	style,
	extra
}) => {
	const supportedLanguages = useSupportedLanguages();

	return (
		<Card style={{ marginBottom: 16, ...style }}>
			<Row gutter={16} align="middle" justify="space-between">
				<Col>
					<Space align="center">
						<GlobalOutlined />
						<Text>语言:</Text>
						<Select
							value={value}
							onChange={onChange}
							style={{ width: 120 }}
							size="middle"
						>
							{supportedLanguages.map((lang) => (
								<Select.Option key={lang.value} value={lang.value}>
									{lang.flag} {lang.label}
								</Select.Option>
							))}
						</Select>
					</Space>
				</Col>
				{extra && <Col>{extra}</Col>}
			</Row>
		</Card>
	);
};

export default ContentLanguageSelector;
